export const FALLBACK_BOB_VERSION = '0.41.0';
export const FALLBACK_NITRO_MODULES_VERSION = '0.35.3';
export const SUPPORTED_MONOREPO_CONFIG_VERSION = '0.3.3';
export const SUPPORTED_REACT_NATIVE_VERSION = '0.85.0';
export const SUPPORTED_EXPO_SDK_VERSION = '55';
